// Libraries
import { Router } from '@angular/router';
// Models
import { ClassChild, AvailableClass } from '../../models';
import { YearLevel } from '../../../common/modules/core/models';
import * as moment from 'moment';
import * as _ from 'lodash';
// Services
import { BookingHolidayService } from '../../services';
import { SessionStorageService, CatalogService } from '../../../common/modules/core/services';

export class BookingComponent {
    protected yearLevels: YearLevel[];
    protected classesChildren: ClassChild[];
    protected availableClasses: AvailableClass[];
    protected loading:boolean;
    
    constructor(
        protected router: Router,
        protected service: BookingHolidayService,
        protected sessionStorageService: SessionStorageService,
        protected catalogService?: CatalogService
    ){
        this.loading = true;
    }

    /**
     * Find selected child object in the classesChildren list based on child Id.
     * @param {number} childId
     * @param {ClasesChild[]} childList
     * @returns {ClasesChild || null} class child object or null;
     */
    protected findSelectedChild(childId: number, childList: ClassChild[]) {
        let result = _.find(childList, {'id': childId});
        
        return result ? result : null;
    }

    // Set holiday children to session
    protected setHolidayChildren(children: any) {
        this.sessionStorageService.setData('holChildren', children);
        // check is ias parent hide profile on menu
		if(children.type == 'ais'){
			this.sessionStorageService.setData('isAisParent', true);
		}
		else {
			this.sessionStorageService.setData('isAisParent', false);
		}
    }
    
    // Get holiday child from session
    protected getHolidayChildren() {
        return this.sessionStorageService.getData('holChildren');
    }

    // Set selected child to session
    protected setSelectedChild(childId: any) {
        this.sessionStorageService.setData('selectedChild', childId);
    }
    
    // Get selected child from session
    protected getSelectedChild() {
        return this.sessionStorageService.getData('selectedChild');
    }

    // Set Q&A Infomation to session
    protected setQuestionAnswer(answerList: any) {
        this.sessionStorageService.setData('answerList', answerList);
    }

    // get Q&A Infomation from session
    protected getQuestionAnswer() {
        return this.sessionStorageService.getData('answerList');
    }

    // Set booking information to session
    protected setBooking(booking: any) {
        this.sessionStorageService.setData('holidayBooking', booking);
    }
    
    // Get booking information from session
    protected getBooking() {
        return this.sessionStorageService.getData('holidayBooking');
    }
    
    backToStudentList(){
        this.router.navigate(['booking/students']);
    }


    /**
     * Go to 'Step 2' of booking - classes list page.
     */
    protected toQuestionAnswerPage() {
        this.router.navigate(['booking/question-answer']);
    }


    /**
     * Go to 'Step 2' of booking - classes list page.
     */
    protected toActivitiesListPage() {
        this.router.navigate(['booking/activites-list']);
    }

    /**
     * Go to 'Step 2.1' of booking - Selected classes.
     */
    protected toSelectedClasses(studentId: number) {
        this.router.navigate(['booking/review-schedule']);
    }

    // Back to activities
    backToActivitiesList() {
        this.router.navigate(['booking/activites-list']);
    }

    // Return to excursion
    backToExcursion() {
        return this.router.navigate(['booking/excursions']);
    }

    // Return to bus
    backToBusOption() {
        this.router.navigate(['booking/bus'])
    }


    // Time format
    protected timeDataFormat(data: string, format: string): string {
        return moment(data).format(format);
    }
    
    // Time UTC format
    protected timeUTCFormat(date: string, format: string): string {
        return moment(date).utc().format(format);
    }
}


// WEBPACK FOOTER //
// ./src/holiday/parent/booking/BookingComponent.ts